import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { combineLatest, Subscription } from 'rxjs';

import { environment } from '../environments/environment';

import { FeedbackService } from './shared/services/feedback/feedback.service';
import { NotificationService } from './shared/services/notification/notification.service';
import { ProtocolDroidService } from './shared/services/protocol-droid/services/protocol-droid.service';
import { CoreSessionService } from './shared/services/session/core-session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[];

  constructor(
    private titleService: Title,
    private droid: ProtocolDroidService,
    private feedbackService: FeedbackService,
    private _session: CoreSessionService,
    private notificationService: NotificationService
  ) {
    this.subscriptions = [];
  }

  async ngOnInit() {
    if (!environment.development) await this.notificationService.init();

    // Handling online / offline events
    window.addEventListener('offline', () => {
      this.feedbackService.showMessage({
        message: 'misc.modals.offline',
        title: 'misc.modals.error-title',
        decoration: 'none',
        type: 'offline',
        titleDefault: 'Oops...',
        keyboard: false
      });
    });

    this.subscriptions.push(
      // flexible "Title"
      combineLatest([this._session.routerEvent$, this.droid.onTranslationChangeEvent]).subscribe(([event]) => {
        const title = this.droid.translate('idechat.header.' + event.location, 'undefined', null, true);
        if (title !== 'undefined') {
          this.titleService.setTitle(title + ' | Ideta');
        } else {
          this.titleService.setTitle('Ideta Nuki');
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }
}
